import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "sonner";
import { registerSW } from "@/lib/webpush";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import MapExplorer from "@/pages/MapExplorer";
import Suggestions from "@/pages/Suggestions";
import Internships from "@/pages/Internships";
import Applications from "@/pages/Applications";
import Favorites from "@/pages/Favorites";
import Profile from "@/pages/Profile";
import CompanyDashboard from "@/pages/CompanyDashboard";
import CompanyCreate from "@/pages/CompanyCreate";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import Vitrine from "@/pages/Vitrine";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Roadmap from "@/pages/Roadmap";
import Analytics from "@/pages/Analytics";
import TeacherClass from "@/pages/TeacherClass";
import Messages from "@/pages/Messages";
import AdminClaims from "@/pages/AdminClaims";
import Claim from "@/pages/Claim";
import WebsiteStudio from "@/pages/WebsiteStudio";
import SitePublic from "@/pages/SitePublic";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function AppRouter() {
  const loc = useLocation();
  const nav = useNavigate();
  useEffect(() => {
    registerSW();
    const handler = (e) => {
      if (e.data?.type === "navigate" && e.data.url) nav(e.data.url);
    };
    if ("serviceWorker" in navigator) navigator.serviceWorker.addEventListener("message", handler);
    return () => {
      if ("serviceWorker" in navigator) navigator.serviceWorker.removeEventListener("message", handler);
    };
  }, [nav]);
  // synchronous check for session_id fragment BEFORE ProtectedRoute runs
  if (loc.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/map" element={<MapExplorer />} />
      <Route path="/suggestions" element={<Suggestions />} />
      <Route path="/internships" element={<Internships />} />
      <Route path="/applications" element={<Applications />} />
      <Route path="/favorites" element={<Favorites />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/company" element={<CompanyDashboard />} />
      <Route path="/company/new" element={<CompanyCreate />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/vitrine/:id" element={<Vitrine />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/roadmap" element={<Roadmap />} />
      <Route path="/analytics" element={<Analytics />} />
      <Route path="/teacher" element={<TeacherClass />} />
      <Route path="/messages" element={<Messages />} />
      <Route path="/admin/claims" element={<AdminClaims />} />
      <Route path="/claim" element={<Claim />} />
      <Route path="/company/:cid/website" element={<WebsiteStudio />} />
      <Route path="/site/:slug" element={<SitePublic />} />
      <Route path="/site/:slug/:pageSlug" element={<SitePublic />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
